<template>
  <div class="index">
    <div class="centered">
      <router-link :to="{ name: 'PartnerEditor', params: { id: 'new' } }" class="button centered">Добавить партнера</router-link>
    </div>
    <ul class="list column is-8 is-offset-2 columns is-multiline">
      <router-link 
        v-for="partner in partners" 
        :to="{ name: 'PartnerEditor', params: { id: partner.id } }" 
        class="column is-half" 
        :key="partner.id"
      >
        <div class="box">
          <img :src='"/upload/photos/" + partner.logo.image' v-if="partner.logo.image"/> <br>
          <strong>{{ partner.title }}</strong><br>
          <span>Ссылка:</span>
          <a :href="partner.url" target="_blank">{{ partner.url }}</a>
          <button class="delete is-pulled-right" @click.prevent="del(partner.id)"></button>
        </div>
      </router-link>
    </ul>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'News',
    data () {
      return {
        dates: null
      }
    },
    computed: {
      ...mapState(['partners'])
    },
    created () {
      this.getPartners()
    },
    methods: {
      ...mapActions(['getPartners', 'deletePartner']),
      del (id) {
        this.$dialog.confirm({
          message: 'Действительно удалить?',
          onConfirm: () => {
            this.deletePartner(id)
            .then(() => this.$toast.open({
              message: 'Партнер удален'
            }))
          }
        })
      }
    }
  }
</script>

<style>
.button.centered {
  margin: 20px 0 10px;
}
.box {
  position: relative;
}
.box img {
  margin: 20px 0 5px;
  max-height: 150px;
}
.delete {
  position: absolute !important;
  top: 5px;
  right: 5px;
}
</style>



// WEBPACK FOOTER //
// Index.vue?578baaba